// Generated by Melange

import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Curry from "melange.js/curry.js";
import * as Mapre_web__Browser from "./browser.js";
import * as Mapre_web__Web_types from "./web_types.js";
import * as Mapre_wire__Json from "../../shared/wire/json.js";

function cancel(t) {
  t.generation = t.generation + 1 | 0;
  Mapre_web__Browser.abort(t.controller);
  t.controller = new AbortController();
}

function dispatch(t, action) {
  if (!/* tag */ (typeof action !== "object" && typeof action !== "function")) {
    return;
  }
  switch (action) {
    case /* Close */ 1 :
      cancel(t);
      return Curry._1(t.emit, {
        TAG: /* Usage */ 38,
        _0: /* Close */ 1
      });
    case /* Open */ 0 :
    case /* Refresh */ 2 :
      break;
    default:
      return;
  }
  const workspace = Mapre_web__Web_types.workspace(Curry._1(t.model, undefined).route);
  if (workspace !== undefined && (Caml_obj.caml_equal(action, /* Open */ 0) || Curry._1(t.model, undefined).usage_form !== undefined)) {
    if (Caml_obj.caml_equal(action, /* Open */ 0)) {
      Curry._1(t.emit, {
        TAG: /* Usage */ 38,
        _0: /* Open */ 0
      });
    }
    cancel(t);
    Curry._1(t.emit, {
      TAG: /* Usage */ 38,
      _0: /* Loading */ 3
    });
    const generation = t.generation;
    Mapre_web__Browser.request(t.controller, undefined, undefined, "/api/workspaces/" + (workspace + "/billing")).then(function (result) {
      const model = Curry._1(t.model, undefined);
      if (generation === t.generation && model.usage_form !== undefined && Caml_obj.caml_equal(Mapre_web__Web_types.workspace(model.route), workspace)) {
        if (result.TAG === /* Ok */ 0) {
          try {
            Curry._1(t.emit, {
              TAG: /* Usage */ 38,
              _0: {
                TAG: /* Loaded */ 0,
                _0: result._0
              }
            });
          }
          catch (raw_exn){
            const exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
            if (exn.MEL_EXN_ID === Mapre_wire__Json.Invalid) {
              Curry._1(t.emit, {
                TAG: /* Usage */ 38,
                _0: {
                  TAG: /* Failed */ 1,
                  _0: "Invalid usage response."
                }
              });
            } else {
              throw exn;
            }
          }
        } else {
          const code = result._0;
          if (/* tag */ typeof code !== "object" && typeof code !== "function" || code.TAG !== /* Failed */ 1) {
            Curry._1(t.emit, {
              TAG: /* Usage */ 38,
              _0: {
                TAG: /* Failed */ 1,
                _0: "Unable to read workspace usage."
              }
            });
            Curry._1(t.failure, code);
          } else {
            Curry._1(t.emit, {
              TAG: /* Usage */ 38,
              _0: {
                TAG: /* Failed */ 1,
                _0: code._0
              }
            });
          }
        }
      }
      return Promise.resolve();
    });
    return;
  }
  
}

function create(emit, model, failure) {
  return {
    emit,
    model,
    failure,
    generation: 0,
    controller: new AbortController()
  };
}

export {
  create,
  cancel,
  dispatch,
}
/* Mapre_web__Browser Not a pure module */
